export * from './universal-modal.component';
export * from './universal-modal.module';
